import * as t from 'io-ts';

export const notificationTag = t.union([t.literal('qingdao_alert'), t.literal('qingdao_alert')]);

export type NotificationTag = t.TypeOf<typeof notification>;

export const notification = t.type({
  id: t.number,
  user: t.number,
  title: t.string,
  content: t.string,
  tags: t.array(notificationTag),
  has_read: t.boolean,
  updated_at: t.string,
  created_at: t.string,
});

export type Notification = t.TypeOf<typeof notification>;

export const notificationPages = t.type({
  count: t.number,
  results: t.array(notification),
});

export const notificationSearchQuery = t.partial({
  tag: notificationTag,
  page: t.number,
});

export type NotificationSearchQuery = t.TypeOf<typeof notificationSearchQuery>;
